import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "data-bs-backdrop"]
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header d-block" }
const _hoisted_5 = { class: "modal-title fw-bold text-black" }
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "modal-footer" }
const _hoisted_8 = ["data-bs-target"]
const _hoisted_9 = ["data-bs-target"]
const _hoisted_10 = ["data-bs-target"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade createNewModal",
    id: _ctx.id,
    tabindex: "-1",
    "aria-hidden": "true",
    "data-bs-backdrop": _ctx.backdrop
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.title ?? _ctx.$t('cta.$delete.title')), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", null, _toDisplayString(_ctx.message), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            type: "button",
            class: "default-btn outlined transition",
            "data-bs-dismiss": "modal",
            "data-bs-target": _ctx.id,
            "aria-label": "Close"
          }, _toDisplayString(_ctx.$t('cta.discard')), 9 /* TEXT, PROPS */, _hoisted_8),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('confirm'))),
            "data-bs-dismiss": "modal",
            "data-bs-target": _ctx.id,
            class: "default-btn transition"
          }, _toDisplayString(_ctx.$t('cta.confirm')), 9 /* TEXT, PROPS */, _hoisted_9)
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn-close shadow-none",
          "data-bs-dismiss": "modal",
          "data-bs-target": _ctx.id,
          "aria-label": "Close"
        }, null, 8 /* PROPS */, _hoisted_10)
      ])
    ])
  ], 8 /* PROPS */, _hoisted_1))
}